const attr = {
  current: 'aria-current',
  slide: 'data-product-gallery-item',
  thumb: 'data-product-gallery-thumb',
  thumbContainer: 'data-product-gallery-thumb-container',
  thumbScroll: 'thumb-scroll'
}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', class extends HTMLElement {
    #observer;
    #visibleSlides = new Set();
    #slideVisibility = new WeakMap();
    #activeSlides = new Set();
    #thumbsUpdateTimer = null;

    connectedCallback() {
      this.addEventListener('click', this.#clickHandle.bind(this));

      this.#observer = new IntersectionObserver(this.#intersectionHandle.bind(this), {
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });
      this.querySelectorAll(`[${attr.slide}]`).forEach($slide => {
        this.#observer.observe($slide);
      });

      this.#scrollToFirstImage();
    }

    #scrollToFirstImage() {
      const $firstSlide = this.querySelector(`[${attr.slide}]`);
      if (!$firstSlide) return;

      $firstSlide.scrollIntoView({
        behavior: 'instant',
        block: 'end'
      });
    }

    disconnectedCallback() {
      this.#observer.disconnect();
    }

    #clickHandle(e) {
      const $thumb = e.target.closest(`[${attr.thumb}]`)
      if ($thumb) {
        this.#thumbClickHandle($thumb);
        return;
      }
    }

    #intersectionHandle(entries) {
      entries.forEach(e => {
        if (!e.isIntersecting) {
          this.#visibleSlides.delete(e.target);
          this.#slideVisibility.set(e.target, 0);
          return;
        }
        this.#visibleSlides.add(e.target);
        this.#slideVisibility.set(e.target, e.intersectionRatio);
      });
      let bestVisibility = 0;
      this.#activeSlides.clear();
      this.#visibleSlides.forEach($slide => {
        const visibility = this.#slideVisibility.get($slide) || 0;
        if (visibility > bestVisibility) {
          this.#activeSlides.clear();
          this.#activeSlides.add($slide);
          bestVisibility = visibility;
          return;
        }
        if (visibility === bestVisibility) {
          this.#activeSlides.add($slide);
        }
      });
      this.#updateThumbs();
    }

    #thumbClickHandle($thumb) {
      const ind = $thumb.getAttribute(attr.thumb);
      const $slide = this.querySelector(`[${attr.slide}="${ind}"]`);
      if (!$slide) {
        return;
      }
      $slide.scrollIntoView({
        behavior: "smooth",
        block: "center"
      })
    }

    #updateThumbs() {
      if (this.#thumbsUpdateTimer) {
        clearTimeout(this.#thumbsUpdateTimer);
        this.#thumbsUpdateTimer = null;
      }
      this.#thumbsUpdateTimer = setTimeout(() => {
        this.querySelectorAll(`[${attr.thumb}]`).forEach($thumb => {
          $thumb.removeAttribute(attr.current);
        })
        this.#activeSlides.forEach($slide => {
          const ind = $slide.getAttribute(attr.slide);
          if (!ind) return;
          const $thumb = this.querySelector(`[${attr.thumb}="${ind}"]`);
          if (!$thumb) return;
          $thumb.setAttribute(attr.current, 'true');
          if (this.hasAttribute(attr.thumbScroll)) {
            const $thumbContainer = this.querySelector(`[${attr.thumbContainer}]`);

            const thumbContainerRect = $thumbContainer.getBoundingClientRect();
            const thumbRect = $thumb.getBoundingClientRect();

            if (thumbRect.top < thumbContainerRect.top) {
              $thumbContainer.scrollTop -= (thumbContainerRect.top - thumbRect.top);
            } else if (thumbRect.bottom > thumbContainerRect.bottom) {
              $thumbContainer.scrollTop += (thumbRect.bottom - thumbContainerRect.bottom);
            }
          }
        });
      }, 20);
    }

  })
}